import React from 'react'
import { Image } from '../atoms/image'

export const BackgroundVideo = () =>
  <div id="background-video">
    <video
      src="/videos/background.mp4"
      poster='/images/normal/poster.jpg'
      autoPlay={true}
      muted={true}
      loop={true}
      controls={false}
      playsInline={true}
    />
  </div>